import { ModalProps } from "antd/lib/modal/Modal";
import { message, Modal, Spin, Table, Tabs } from "antd";
import React, { useMemo, useState } from "react";
import {
    deadInteraction,
    deadLineProps,
    endInteraction,
    entInteractionProps,
    NotEndAxios,
    NotEndStu,
    NotEndTypes,
    publishCheck
} from "../../../../../../../service/score";
import useRequestFn from "../../../../../../../utils/useRequestFn";
import List from "../List";
import { errorMessage } from "../../../../../../../service/service";
import useRequest from "../../../../../../../utils/useRequest";
import { ColumnProps } from "antd/lib/table/interface";

interface Props extends ModalProps {
    onSuccess: () => void;
    courseNo: string;
    courseSeq: string;
}

const Index = ({ onSuccess, courseSeq, courseNo, ...props }: Props) => {
    const [checkData, { loading: checkLoading }, reCheck] = useRequest(
        () => publishCheck(courseNo, courseSeq),
        {},
        [courseSeq, courseSeq]
    );

    const [endInteractionAction, { loading: endInteractionLoading }] =
        useRequestFn(endInteraction);
    const [deadInteractionAction, { loading: deadInteractionLoading }] =
        useRequestFn(deadInteraction);

    const saveLoading = useMemo(() => {
        return [deadInteractionLoading, endInteractionLoading].some(i => i);
    }, [deadInteractionLoading, endInteractionLoading]);

    const [showKey, setShowKey] = useState<NotEndTypes>(NotEndTypes.Exam);

    async function overAll(data: NotEndAxios[] | undefined) {
        if (!data) {
            return;
        }
        try {
            const o: deadLineProps & entInteractionProps = {};
            switch (showKey) {
                case NotEndTypes.Exam:
                    o.examIds = data.map(item => item.id);
                    break;
                case NotEndTypes.GroupActivity:
                    o.groupActivityIds = data.map(item => item.id);
                    break;
                case NotEndTypes.Homework:
                    o.homeworkIds = data.map(item => item.id);
                    break;
                case NotEndTypes.SignIn:
                    o.signInIds = data.map(item => item.id);
                    break;
                case NotEndTypes.Exercise:
                    o.exerciseIds = data.map(item => item.id);
                    break;
                case NotEndTypes.Vote:
                    o.voteIds = data.map(item => item.id);
                    break;
            }
            if (data[0]?.deadline || data[0]?.endTime || data[0]?.beginTime) {
                await deadInteractionAction(o);
            } else {
                await endInteractionAction(o);
            }
            await reCheck();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    const columns: ColumnProps<NotEndStu>[] = [
        {
            title: "学生信息",
            align: "center",
            width: "50%",
            render: (v, row) => (
                <span>
                    {row.studentName}-{row.studentNo}
                </span>
            )
        },
        {
            title: "总分",
            align: "center",
            dataIndex: "totalGrade"
        }
    ];

    return (
        <Modal {...props} footer={null} width={800} title="发布成绩前校验">
            <Spin spinning={[saveLoading || checkLoading].some(i => i)}>
                <Tabs
                    onChange={key => setShowKey(key as NotEndTypes)}
                    type="card">
                    <Tabs.TabPane
                        tab={`考试(${checkData?.notDeadlineExam?.length || 0})`}
                        key={NotEndTypes.Exam}>
                        <List
                            overOne={value => overAll([value])}
                            overAll={() => overAll(checkData?.notDeadlineExam)}
                            data={checkData?.notDeadlineExam}
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane
                        tab={`作业(${
                            checkData?.notDeadlineHomework?.length || 0
                        })`}
                        key={NotEndTypes.Homework}>
                        <List
                            overOne={value => overAll([value])}
                            overAll={() =>
                                overAll(checkData?.notDeadlineHomework)
                            }
                            data={checkData?.notDeadlineHomework}
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane
                        tab={`小组活动(${
                            checkData?.notDeadlineGroupActivity?.length || 0
                        })`}
                        key={NotEndTypes.GroupActivity}>
                        <List
                            overOne={value => overAll([value])}
                            overAll={() =>
                                overAll(checkData?.notDeadlineGroupActivity)
                            }
                            data={checkData?.notDeadlineGroupActivity}
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane
                        tab={`投票(${checkData?.notEndVote?.length || 0})`}
                        key={NotEndTypes.Vote}>
                        <List
                            overOne={value => overAll([value])}
                            overAll={() => overAll(checkData?.notEndVote)}
                            data={checkData?.notEndVote}
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane
                        tab={`签到(${checkData?.notEndSignIn?.length || 0})`}
                        key={NotEndTypes.SignIn}>
                        <List
                            overOne={value => overAll([value])}
                            overAll={() => overAll(checkData?.notEndSignIn)}
                            data={checkData?.notEndSignIn}
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane
                        tab={`超过100分学生(${
                            checkData?.greatThenHundredStudents?.length || 0
                        })`}
                        key={NotEndTypes.Stu}>
                        <Table
                            key="studentNo"
                            bordered
                            columns={columns}
                            dataSource={checkData?.greatThenHundredStudents}
                        />
                    </Tabs.TabPane>
                </Tabs>
            </Spin>
        </Modal>
    );
};
export default Index;
